import { render, staticRenderFns } from "./MenuSolo.vue?vue&type=template&id=7664feca&"
import script from "./MenuSolo.vue?vue&type=script&lang=js&"
export * from "./MenuSolo.vue?vue&type=script&lang=js&"
import style0 from "./MenuSolo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports